import { observable, action, runInAction, makeObservable } from 'mobx';
import api from './api';
import { REQUEST_STATUS_IDLE, REQUEST_STATUS_LOADING, REQUEST_STATUS_LOADED } from '../constants/common';

class Regions {
  status = REQUEST_STATUS_IDLE;

  regions = [];

  constructor() {
    makeObservable(this, {
      regions: observable,
      getRegions: action,
      init: action,
    });
  }

  getRegions() {
    this.status = REQUEST_STATUS_LOADING;

    return api.get('regions').then((response) => {
      if (!response.ok) {
        this.status = REQUEST_STATUS_LOADED;
        return;
      }

      const { data } = response;
      const regions = data.map(({ properties }) => ({
        label: `[${properties.code}] ${properties.display_name}`,
        value: properties.code,
      }));

      runInAction(() => {
        this.regions = regions;
        this.status = REQUEST_STATUS_LOADED;
      });
    });
  }

  // Loads the regions once per session. Every caller gets the same request back, so it can wait for the regions
  // even when another page already started (or finished) loading them; a failed load resolves with no regions.
  init() {
    if (!this.request || ![REQUEST_STATUS_LOADING, REQUEST_STATUS_LOADED].includes(this.status)) {
      this.request = this.getRegions().then(() => undefined);
    }
    return this.request;
  }
}

export default Regions;
